import React, { useEffect, useState } from 'react';
import { TextField, Button, Typography, Box, Container, Paper } from '@mui/material';
import { BrowserRouter, Route, Routes, Link, Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";

function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const params = useParams(); 
    const [searchParams, setSearchParams] = useSearchParams();
    const searchTerm = searchParams.get('testKey');
    const queryList = [...searchParams];

    useEffect(() => {
//        console.log("login use Effect  userData :" + JSON.stringify(userData))

        checkLogin();
    }, [userData]);

    const checkLogin = () => {
        //("call login checkLogin")
        if (isLogin()) {
            navigate('/home');
        }
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        // Handle login logic here (e.g., API call for authentication)

        login();

        //('Login submitted:', { email, password });
    };


    const login = async () => {

        try {

            const reqData = {};
            reqData.userEmail = email;
            reqData.userPW = password;


            let response = await axios.post("/api/booking/CheckUser", reqData);
            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                let userInfo = response.data.result;
                var newData = {}
                newData.userEmail = userInfo.userEmail;
                newData.userPhone = userInfo.userPhone;
                newData.userName = userInfo.userName;
                newData.chargeMoney = userInfo.chargeMoney;
                newData.chargeCount = userInfo.chargeCount;
                newData.bonusCount = userInfo.bonusCount;
                newData.userLevel = userInfo.userLevel;
                newData.unlimitUser = userInfo.unlimitUser;
                newData.unlimitSeller = userInfo.unlimitSeller;

                updateUserInfo(newData);
//                console.log("login save new userdata")
//                checkLogin();


            }
        } catch (err) {
            console.error(err);
        }

    }


    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ marginTop: 10, padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography component="h1" variant="h5">
                    로그인
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="이메일"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="패스워드"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={email.length > 0 && password.length > 0 ? false : true}
                    >
                        로그인
                    </Button>
                    {/*<Link to="/register">회원가입</Link>*/}
                </Box>
            </Paper>
        </Container>
    );
}

export default Login;